import { Suspense, type PropsWithChildren } from 'react'

import { BuscaClienteSkeleton } from '@/features/clientes/components/busca-cliente-skeleton'
import { CadastroClienteSkeleton } from '@/features/clientes/components/cadastro-cliente-skeleton'
import { PageLayoutSkeleton } from '@/layouts/page'
import { ConfiguracoesParametrosSkeleton } from '@/pages/configuracoes/parametros/configuracoes-parametros.skeleton'
import { ConfiguracoesReservaSkeleton } from '@/pages/configuracoes/reserva/configuracoes-reserva.skeleton'
import { ConsultaLeadsRepresadosPageSkeleton } from '@/pages/consulta-leads-represados'
import { DetalhesLeadRepresadoPageSkeleton } from '@/pages/detalhes-lead-represado'
import { UltimosAtendimentosPageSkeleton } from '@/pages/ultimos-atendimentos'

export const BuscarClientePageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <BuscaClienteSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
export const CadastrarClientePageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <CadastroClienteSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
export const UltimosAtendimentosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <UltimosAtendimentosPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConsultaLeadsRepresadosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConsultaLeadsRepresadosPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const DetalhesLeadRepresadoPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <DetalhesLeadRepresadoPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConfiguracoesReservaPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesReservaSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConfiguracoesParametrosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesParametrosSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
